import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import formatDateAndTime from "../../common/formatDateAndTime";
import getactions from "../../common/getactions";
import moment from "moment";

const Assignagents = ({
  bookingId,
  summaryDetails,
  setFleetDeliveryAgentList,
  fleetDeliveryAgentList,
  fleetDeliveryAgentBooking,
  fleetPickupAgentList,
  setFleetPickupAgentList,
  fleetPickupAgentBooking,
}) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const profile = JSON.parse(localStorage.getItem("profile"));
  let token = localStorage.getItem("token");
  const [usersList, setUsersList] = useState([]);
  // const [fleetDeliveryAgentList, setFleetDeliveryAgentList] = useState([]);
  // const [fleetPickupAgentList, setFleetPickupAgentList] = useState([]);
  const [selectedDeliveryAgent, setSelectedDeliveryAgent] = useState(null);
  const [selectedPickupAgent, setSelectedPickupAgent] = useState(null);
  const actionsToAccess = getactions(profile?.roles, profile?.actions);

  function createData(
    AgentId,
    Name,
    Email,
    // Mobile,
    // AssigneeName,
    // AssigneeEmail,
    CreatedOn
  ) {
    return {
      AgentId,
      Name,
      Email,
      // Mobile,
      // AssigneeName,
      // AssigneeEmail,
      CreatedOn,
    };
  }

  const deliveryHistory = fleetDeliveryAgentList[0]?.deliveryAgentHistory
    ? Array.isArray(fleetDeliveryAgentList[0].deliveryAgentHistory)
      ? fleetDeliveryAgentList[0].deliveryAgentHistory
      : [fleetDeliveryAgentList[0].deliveryAgentHistory]
    : fleetDeliveryAgentList;

  const pickupHistory = fleetPickupAgentList[0]?.pickupAgentHistory
    ? Array.isArray(fleetPickupAgentList[0].pickupAgentHistory)
      ? fleetPickupAgentList[0].pickupAgentHistory
      : [fleetPickupAgentList[0].pickupAgentHistory]
    : fleetPickupAgentList;

  const rows = deliveryHistory.map((item) =>
    createData(
      item?.agentId || "-",
      item?.agentName,
      item?.agentEmail,
      // item?.agentContactNumber || "-",
      // fleetDeliveryAgentList[0]?.assigneeName,
      // fleetDeliveryAgentList[0]?.assigneeEmail || "-",
      formatDateAndTime(item?.createdAt) || "-"
    )
  );

  const pickuprows = (pickupHistory || []).map((item) =>
    createData(
      item?.agentId || "-",
      item?.agentName,
      item?.agentEmail,
      // item?.agentContactNumber || "-",
      // item?.assigneeName,
      // item?.assigneeEmail || "-",
      formatDateAndTime(item?.createdAt) || "-"
    )
  );

  const getUsersList = async () => {
    try {
      const response = await fetch(
        `${apiUrl}/api/users?limit=100&isAgent=1&cityId=${summaryDetails?.cityId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setUsersList(data?.entities?.rows);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Users List:", error);
    }
  };

  const handleAssign = async (type) => {
    let body;
    let endUrl;
    if (type === "Delivery") {
      endUrl = "fleetdeliveryagentbookings";
      if (fleetDeliveryAgentList.length > 0) {
        body = {
          id: fleetDeliveryAgentList[0]?.id,
          agentId: selectedDeliveryAgent?.id,
          agentName: selectedDeliveryAgent?.name,
          agentEmail: selectedDeliveryAgent?.email,
          assignedBy: profile?.id,
          assigneeEmail: profile?.email,
          assigneeName: profile?.name,
          agentContactNumber: selectedDeliveryAgent?.mobile,
          deliveryType: summaryDetails?.deliveryType,
          deliveryTypeInt: summaryDetails?.deliveryTypeInt,
          deliveryDate: moment(summaryDetails?.bookFrom).format(
            "YYYY-MM-DDTHH:mm"
          ),
          vehicleId: summaryDetails?.vehicleId,
          vehicleRegistrationNo: summaryDetails?.vehicleInfo?.licensePlate,
          isUpdateAgent: true,
          deliveryAgentHistory: [
            {
              bookingId: bookingId,
              agentId: selectedDeliveryAgent?.id,
              agentName: selectedDeliveryAgent?.name,
              agentEmail: selectedDeliveryAgent?.email,
              assignedBy: profile?.id,
            },
          ],
        };
      } else {
        body = {
          bookingId: bookingId,
          bookingCode: summaryDetails?.bookingCode,
          agentId: selectedDeliveryAgent?.id,
          agentName: selectedDeliveryAgent?.name,
          agentEmail: selectedDeliveryAgent?.email,
          assignedBy: profile?.id,
          assigneeEmail: profile?.email,
          assigneeName: profile?.name,
          agentContactNumber: selectedDeliveryAgent?.mobile,
          deliveryType: summaryDetails?.deliveryType,
          deliveryTypeInt: summaryDetails?.deliveryTypeInt,
          deliveryDate: moment(summaryDetails?.bookFrom).format(
            "YYYY-MM-DDTHH:mm"
          ),
          vehicleId: summaryDetails?.vehicleId,
          vehicleRegistrationNo: summaryDetails?.vehicleInfo?.licensePlate,
          deliveryAgentHistory: [
            {
              bookingId: bookingId,
              agentId: selectedDeliveryAgent?.id,
              agentName: selectedDeliveryAgent?.name,
              agentEmail: selectedDeliveryAgent?.email,
              assignedBy: profile?.id,
            },
          ],
          cityId: summaryDetails?.cityId,
          // deliveryDate : formattedDeliveryDate
        };
      }
    } else {
      endUrl = "fleetpickupagentbookings";
      if (fleetPickupAgentList.length > 0) {
        body = {
          id: fleetPickupAgentList[0]?.id,
          agentId: selectedPickupAgent?.id,
          agentName: selectedPickupAgent?.name,
          agentEmail: selectedPickupAgent?.email,
          assignedBy: profile?.id,
          assigneeEmail: profile?.email,
          assigneeName: profile?.name,
          agentContactNumber: selectedPickupAgent?.mobile,
          deliveryType: summaryDetails?.deliveryType,
          deliveryTypeInt: summaryDetails?.deliveryTypeInt,
          pickupDate: moment(summaryDetails?.bookTo).format("YYYY-MM-DDTHH:mm"),
          vehicleId: summaryDetails?.vehicleId,
          vehicleRegistrationNo: summaryDetails?.vehicleInfo?.licensePlate,
          isUpdateAgent: true,
          pickupAgentHistory: [
            {
              bookingId: bookingId,
              agentId: selectedPickupAgent?.id,
              agentName: selectedPickupAgent?.name,
              agentEmail: selectedPickupAgent?.email,
              assignedBy: profile?.id,
            },
          ],
        };
      } else {
        body = {
          bookingId: bookingId,
          bookingCode: summaryDetails?.bookingCode,
          agentId: selectedPickupAgent?.id,
          agentName: selectedPickupAgent?.name,
          agentEmail: selectedPickupAgent?.email,
          assignedBy: profile?.id,
          assigneeEmail: profile?.email,
          assigneeName: profile?.name,
          agentContactNumber: selectedPickupAgent?.mobile,
          pickupType: summaryDetails?.pickupType,
          pickupTypeInt: summaryDetails?.pickupTypeInt,
          cityId: summaryDetails?.cityId,
          pickupDate: moment(summaryDetails?.bookTo).format("YYYY-MM-DDTHH:mm"),
          vehicleId: summaryDetails?.vehicleId,
          vehicleRegistrationNo: summaryDetails?.vehicleInfo?.licensePlate,
          pickupAgentHistory: [
            {
              bookingId: bookingId,
              agentId: selectedPickupAgent?.id,
              agentName: selectedPickupAgent?.name,
              agentEmail: selectedPickupAgent?.email,
              assignedBy: profile?.id,
            },
          ],
        };
      }
    }

    try {
      const response = await fetch(`${apiUrl}/api/${endUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(body),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        if (type === "Delivery") {
          fleetDeliveryAgentBooking(data?.dataValues.bookingId);
        } else {
          fleetPickupAgentBooking(data?.dataValues.bookingId);
        }
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Users List:", error);
    }
  };  

  useEffect(() => {
    getUsersList();
  }, []);

  useEffect(() => {
    // fleetDeliveryAgentBooking(bookingId);
    fleetPickupAgentBooking(bookingId);
  }, [bookingId]);

  return (
    <div>
      <div className="md:p-6">
        <h2 className="text-2xl font-semibold text-[#2c3e50] mb-8">
          Assign Fleet Agents Details
        </h2>

        <div className="overflow-hidden rounded-lg shadow mb-8">
          <div className="w-full text-left bg-white">
            <div className="bg-[#34495e] text-white">
              <h1 className="px-6 py-4 text-left" colSpan={2}>
                Assign Agent for Delivery
              </h1>
            </div>
            {actionsToAccess?.includes("Assign Pickup And Delivery Agent") && (
              <div className="flex items-center gap-4 px-6 py-6">
                <select
                  id="deliveryagent"
                  required
                  onChange={(e) => {
                    const selectedId = e.target.value;
                    const selectedUser = usersList.find(
                      (user) => String(user.id) === selectedId
                    );
                    if (selectedUser) {
                      setSelectedDeliveryAgent({
                        id: selectedUser.id,
                        name: selectedUser.name,
                        email: selectedUser.email,
                        mobile: selectedUser?.mobile,
                      });
                    }
                  }}
                  className="w-full border-2 border-gray-200 rounded-lg p-3 focus:ring focus:ring-blue-100"
                >
                  <option value="">Select Delivery Agent</option>
                  {usersList?.map((item, index) => {
                    return (
                      <option
                        className="text-black"
                        key={index}
                        name={item?.name}
                        value={item?.id}
                      >
                        {item?.name +
                          " - " +
                          item?.email +
                          " - " +
                          item?.mobile}
                      </option>
                    );
                  })}
                </select>
                <button
                  onClick={() => {
                    handleAssign("Delivery");
                  }}
                  className="px-[30px] py-[12.5px] bg-[#2ba8fb] text-white font-bold rounded-full transition-all duration-500 hover:bg-[#6fc5ff] hover:shadow-[0_0_20px_rgba(111,197,255,0.31)] hover:scale-110 active:bg-[#3d94cf] active:scale-95 active:shadow-none"
                >
                  Assign
                </button>
              </div>
            )}

            {fleetDeliveryAgentList.length > 0 && (
              <div className="md:col-span-3 bg-white border rounded-xl shadow-md p-6">
                <TableContainer component={Paper}>
                  <Table
                    sx={{ minWidth: 650 }}
                    size="small"
                    aria-label="dynamic table"
                  >
                    <TableHead>
                      <TableRow className="bg-gray-100">
                        {/* Dynamically render headers */}
                        {rows.length > 0 &&
                          Object.keys(rows[0]).map((key) => (
                            <TableCell key={key}>{key}</TableCell>
                          ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rows.map((row, index) => (
                        <TableRow key={index}>
                          {Object.entries(row).map(([key, value], idx) => (
                            <TableCell key={idx}>
                              {key === "attachments" && value ? (
                                <div
                                  title="image"
                                  className="flex gap-4 items-center cursor-pointer"
                                >
                                  {value.map((item, index) => (
                                    <div
                                      key={index}
                                      className="items-center gap-2"
                                    >
                                      <img
                                        src={item?.url}
                                        alt="Attachment"
                                        className="w-8 h-8 object-contain"
                                      />
                                    </div>
                                  ))}
                                </div>
                              ) : (
                                value
                              )}
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            )}
          </div>
        </div>

        {/* Trip End Details */}
        <div className="overflow-hidden rounded-lg shadow mb-8">
          <div className="w-full text-left bg-white">
            <div className="bg-[#34495e] text-white">
              <h1 className="px-6 py-4 text-left" colSpan={2}>
                Assign Agent to Pickup
              </h1>
            </div>
            {actionsToAccess?.includes("Assign Pickup And Delivery Agent") && (
              <div className="flex items-center gap-4 px-6 py-6">
                <select
                  id="pickupagent"
                  required
                  onChange={(e) => {
                    const selectedId = e.target.value;
                    const selectedUser = usersList.find(
                      (user) => String(user.id) === selectedId
                    );
                    if (selectedUser) {
                      setSelectedPickupAgent({
                        id: selectedUser.id,
                        name: selectedUser.name,
                        email: selectedUser.email,
                        mobile: selectedUser?.mobile,
                      });
                    }
                  }}
                  className="w-full border-2 border-gray-200 rounded-lg p-3 focus:ring focus:ring-blue-100"
                >
                  <option value="">Select Pickup Agent</option>
                  {usersList?.map((item, index) => {
                    return (
                      <option
                        className="text-black"
                        key={index}
                        value={item?.id}
                      >
                        {item?.name +
                          " - " +
                          item?.email +
                          " - " +
                          item?.mobile}
                      </option>
                    );
                  })}
                </select>
                <button
                  onClick={() => {
                    handleAssign("Pickup");
                  }}
                  className="px-[30px] py-[12.5px] bg-[#2ba8fb] text-white font-bold rounded-full transition-all duration-500 hover:bg-[#6fc5ff] hover:shadow-[0_0_20px_rgba(111,197,255,0.31)] hover:scale-110 active:bg-[#3d94cf] active:scale-95 active:shadow-none"
                >
                  Assign
                </button>
              </div>
            )}
            {fleetPickupAgentList.length > 0 && (
              <div className="md:col-span-3 bg-white border rounded-xl shadow-md p-6">
                <TableContainer component={Paper}>
                  <Table
                    sx={{ minWidth: 650 }}
                    size="small"
                    aria-label="dynamic table"
                  >
                    <TableHead>
                      <TableRow className="bg-gray-100">
                        {pickuprows.length > 0 &&
                          Object.keys(pickuprows[0]).map((key) => (
                            <TableCell key={key}>{key}</TableCell>
                          ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {pickuprows.map((row, index) => (
                        <TableRow key={index}>
                          {Object.entries(row).map(([key, value], idx) => (
                            <TableCell key={idx}>
                              {key === "attachments" && value ? (
                                <div
                                  title="image"
                                  className="flex gap-4 items-center cursor-pointer"
                                >
                                  {value.map((item, index) => (
                                    <div
                                      key={index}
                                      className="items-center gap-2"
                                    >
                                      <img
                                        src={item?.url}
                                        alt="Attachment"
                                        className="w-8 h-8 object-contain"
                                      />
                                    </div>
                                  ))}
                                </div>
                              ) : (
                                value
                              )}
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Assignagents;
